const workspaceQuery = (workspaceId, prefix = '?') => workspaceId
  ? `${prefix}workspace_id=${encodeURIComponent(workspaceId)}`
  : '';

export const vitrineGetSettings = ({ request, accountId, workspaceId }) =>
  request(`/api/v1/ozon-vitrine/${accountId}/settings${workspaceQuery(workspaceId)}`);

export const vitrineSaveSettings = ({ request, accountId, payload }) =>
  request(`/api/v1/ozon-vitrine/${accountId}/settings`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  });

export const vitrineRequestCheck = ({ request, accountId, workspaceId }) =>
  request(`/api/v1/ozon-vitrine/${accountId}/check${workspaceQuery(workspaceId)}`, {
    method: 'POST',
    body: JSON.stringify({}),
  });

export const vitrineManualCostPreview = ({ request, accountId, workspaceId }) =>
  request(`/api/v1/ozon-vitrine/${accountId}/cost-preview/manual${workspaceQuery(workspaceId)}`);

export const vitrineAutoCostPreview = ({ request, accountId, workspaceId, scheduleJson }) =>
  request(`/api/v1/ozon-vitrine/${accountId}/cost-preview/auto${workspaceQuery(workspaceId)}`, {
    method: 'POST',
    body: JSON.stringify({ schedule_json: scheduleJson || null }),
  });

export const vitrineGetPricePivot = ({ request, accountId, limit = 5 }) =>
  request(`/api/v1/ozon-vitrine/${accountId}/prices/pivot?limit=${limit}`);

// Grouped history: the backend computes values only for the columns currently
// visible, so every expand/collapse is a fresh (small) request.
// `level` ('month' | 'week' | 'day') cuts the whole history at one level — a
// flat series for trends; expand/collapse are then ignored by the backend.
export const vitrineGetGroupedPivot = ({ request, accountId, months = 6, expand = [], collapse = [], level = null }) => {
  const params = new URLSearchParams({ months: String(months) });
  if (level) params.set('level', level);
  if (expand.length) params.set('expand', expand.join(','));
  if (collapse.length) params.set('collapse', collapse.join(','));
  return request(`/api/v1/ozon-vitrine/${accountId}/prices/pivot/grouped?${params.toString()}`);
};

export const vitrinePollTask = ({ request, accountId, taskId }) =>
  request(`/api/v1/ozon-vitrine/${accountId}/tasks/${taskId}/poll`, {
    method: 'POST',
    body: JSON.stringify({}),
  });

export const vitrineListTasks = async ({ request, accountId, workspaceId, limit = 20 }) => {
  const data = await request(`/api/v1/ozon-vitrine/${accountId}/tasks?limit=${limit}${workspaceQuery(workspaceId, '&')}`);
  return data.tasks || [];
};

export const vitrineRequeueTask = ({ request, accountId, taskId }) =>
  request(`/api/v1/ozon-vitrine/${accountId}/tasks/${taskId}/requeue`, {
    method: 'POST',
    body: JSON.stringify({}),
  });

export const vitrineCancelTask = ({ request, accountId, taskId }) =>
  request(`/api/v1/ozon-vitrine/${accountId}/tasks/${taskId}/cancel`, {
    method: 'POST',
    body: JSON.stringify({}),
  });

export const vitrineGetLatestPrices = async ({ request, accountId }) => {
  const data = await request(`/api/v1/ozon-vitrine/${accountId}/prices`);
  return data.items || [];
};

export const vitrineGetPriceHistory = async ({ request, accountId, offerId }) => {
  const data = await request(`/api/v1/ozon-vitrine/${accountId}/prices/${encodeURIComponent(offerId)}/history`);
  return data.history || [];
};
